import { MbscResource } from "@mobiscroll/react";

// Definición de defaults

export const defaultSala: SalaProps = { idSala: 0, descripcion: '', activo: false, tradicional: false, }

// Creación de interfaces

export interface SalaProps  {
    idSala:            number;
    descripcion:       string;
    tradicional:       boolean;
    activo:            boolean;
}

export interface SalaAsignarProps extends MbscResource {
    activo:            boolean;
}